
import { useEffect, useState } from 'react';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
  faCheck,
  faRedoAlt,
  faTimes,
} from '@fortawesome/free-solid-svg-icons';

import moment from 'moment';
import API, { SYS } from 'service/api';
import Util from 'service/util';

import Protected from 'component/Protected';
import PopMessage from 'component/pop-msg/PopMessage';

const SimBillRow = ({vehicle, bill, readOnly, ...props}) =>
{
  const [discount, setDiscount] = useState(bill.discount);

  const SYS_deleteBill = () =>
  {
    let { company, ix_yrmo, uid } = bill;
    let { cd_license } = vehicle;
    if (!window.confirm(`刪除 ${company}-${cd_license} 在 ${ix_yrmo} 的月費可能會導致賬目錯誤，是否要繼續移除操作？`))
    {
      return false;
    }

    // execute
    let dto = { company, ix_yrmo, uid, cd_license };
    SYS.deleteBill(dto).then(resp => {
      if (!resp.success)
        PopMessage.show(resp.msg, '操作失敗', 'danger');
      else {
        PopMessage.show('成功', '成功', 'success');
        props.onUpdated();
      }
    });
  }

  const updateDiscount = () =>
  {
    let dto = {
      company: bill.company,
      ix_yrmo: bill.ix_yrmo,
      uid: bill.uid,
      cd_license: vehicle.cd_license,
      discount
    };
    API.editDiscount(dto).then(resp => {
      if (!resp.success) {
        PopMessage.show(resp.msg, '更新失敗', 'danger');
      } else {
        PopMessage.show('已更新折扣', '成功', 'success');
        props.onUpdated();
      }
    });
  }

  const recalcMonth = () => {
    API.recalcCustBills(bill.uid, bill.ix_yrmo, { count: 1 }).then(resp => {
      if (!resp.success) {
        PopMessage.show(resp.msg, '連接失敗', 'danger');
      } else {
        PopMessage.show(resp.msg, '成功', 'success');
        props.onUpdated();
      }
    })
  }

  const hasExtraFee = (ix) => {
    let mo1st = moment(`${ix}01`, 'YYYYMMDD');
    let moend = moment(mo1st).endOf('month');

    for (let idx in vehicle.services)
    {
      let s = vehicle.services[idx];
      let sd = moment(s.start_dtm);
      let ed = s.end_dtm && moment(s.end_dtm);
      if ( moend.isAfter(sd) && (!ed || mo1st.isBefore(ed)) )
      { // in range
        if (s.extra_fee > 0) { return true; }
      }
    }
    return false;
  }

  //-------------------------------------------
  useEffect(() => {
    setDiscount(bill.discount);
  }, [bill]);

  return (
    <tr className={props.className + (bill.ix_yrmo && !bill.qualified ? ' outstanding':'')}>
      <Protected>
        <td>
          { !!vehicle && !!bill.year &&
            <button className="small red btn" title="移除紀錄" onClick={SYS_deleteBill}>
              <FontAwesomeIcon icon={faTimes} />
            </button>
          }
        </td>
      </Protected>
      <td className="col-bill-qualify">
        { bill.qualified
         ?<FontAwesomeIcon icon={faCheck} title="已付" />
         :(!!bill.year &&
          <Protected allow={['ADMIN','OPERATOR']}>
            <button className="small orange btn" onClick={ recalcMonth }>
              <FontAwesomeIcon icon={faRedoAlt} />
            </button>
          </Protected>)
        }
      </td>
      <td className="col-bill-year"><strong>{ bill.year }</strong></td>
      <td className="col-bill-month"><strong className="right">{ bill.month }</strong></td>
      <td className="col-bill-fee">{ bill.amount }</td>
      <td className="col-bill-discount">
        { // TODO: discount handling not decided: may need approval
          readOnly
          ?<span>{ discount }</span>
          :<input value={ discount }
            type="number" className="txt-bill-discount"
            placeholder="折扣金額"
            onChange={ e=>setDiscount( parseFloat(e.target.value) ) } />
        }
      </td>
      { !vehicle &&
        <td className="col-bill-paid">
          { bill.paid }
        </td>
      }
      <td className="col-bill-total">
        { readOnly
          ? Util.nf( bill.total )
          : Util.nf( bill.amount - discount )
        }
      </td>
      <td className="col-bill-btn-grp">
        { // TODO: discount handling not decided: may need approval
          !readOnly &&
          <div className="button-group">
            { !hasExtraFee(bill.ix_yrmo) &&
              <>
              <button type="button" className="btn small green" onClick={e=>setDiscount( Math.round(bill.amount*.50) )}>半</button>
              <button type="button" className="btn small green" onClick={e=>setDiscount( Math.round(bill.amount*.30) )}>95</button>
              <button type="button" className="btn small green" onClick={e=>setDiscount( Math.round(bill.amount*.12) )}>98</button>
              </>
            }
            <button type="button" className="btn small blue"  onClick={updateDiscount}>儲存</button>
          </div>
        }
      </td>
    </tr>
  );
}

//================================================================================

const BillListTable = ({company, vehicle, bills, ...props}) =>
{
  const [ixl, setIxl]     = useState([]);
  const [ixMap, setIxMap] = useState({});

  useEffect(() => {
    let _ixMap = bills.reduce((r,x) =>
    {
      // skip hidden vehicles
      if (vehicle && vehicle.deleted) return r;
      // filter by selected company
      if (company && (company !== x.company)) return r;
      // filter by selected vehicle
      if (vehicle && vehicle.cd_license !== x.cd_license) return r;

      //--------------------------------------------------------
      // create indexed object
      if (!r[x.ix_yrmo]) r[x.ix_yrmo] = {
        company: x.company,
        uid: x.uid,
        ix_yrmo: x.ix_yrmo,
        year: moment(x.ix_yrmo, 'YYYYMM').format('YYYY'),
        month: moment(x.ix_yrmo, 'YYYYMM').format('MMM'),
        amount:0, discount:0, paid: 0, total: 0,
        qualified: true
      };

      { // sum prices up by year-month index
        let o = r[x.ix_yrmo];
        o.amount    += x.amount;
        o.discount  += x.discount;
        o.qualified &= x.qualified;
        if (x.qualified) o.paid += (x.amount - x.discount);
        else o.total += x.amount - x.discount;
      }
      return r;
    }, {});

    //---------------------------------------------
    // init
    let _ixl = Object.keys(_ixMap);
    _ixl.sort();

    // skip paid
    for (let i = 0; i < _ixl.length; i++)
    {
      let x = _ixMap[_ixl[i]];
      if (!x.qualified || x.amount != 0)
      {
        _ixl = _ixl.slice(i);
        break;
      }
    }
    for (let i = _ixl.length-1; i >= 0; i--)
    {
      let x = _ixMap[_ixl[i]];
      if (0 == i)
      {
        _ixl = _ixl.slice(Math.max(0, _ixl.length-12));
      }
      else if (!x.qualified || x.amount != 0)
      {
        _ixl = _ixl.slice(0, i+1);
        break;
      }
    }

    setIxMap(_ixMap);
    setIxl(_ixl);
  }, [company, vehicle]);

  // render readonly parts
  // push total row
  let total = Object.values(ixMap)
    .filter(x => !x.qualified)
    .reduce((r,x) => r + (x.total), 0);

  return (
    <div className="bills">
      <table className="data-table full-width">
        <colgroup>
          <Protected>
            <col width="36px" id="col-bill-sysbtn" />
          </Protected>
          <col width="36px"  id="col-bill-qualify"/>
          <col width="60px"  id="col-bill-year"/>
          <col width="60px"  id="col-bill-month"/>
          <col width="auto"  id="col-bill-fee"/>
          <col width="auto"  id="col-bill-discount"/>
          { !vehicle &&
            <col width="auto"  id="col-bill-paid"/>
          }
          <col width="auto"  id="col-bill-total"/>
          <col width="140px" id="col-bill-btn-grp"/>
        </colgroup>
        <thead>
          <tr>
            <Protected>
              <th className="col-bill-sysbtn"></th>
            </Protected>
            <th className="col-bill-qualify"></th>
            <th className="col-bill-year"></th>
            <th className="col-bill-month"></th>
            <th className="col-bill-fee">月費</th>
            <th className="col-bill-discount">折扣</th>
            { !vehicle &&
              <th className="col-bill-paid">已付</th>
            }
            <th className="col-bill-total">應付</th>
            <th className="col-bill-btn-grp"></th>
          </tr>
        </thead>
        <tbody>
          { ixl.map(ix =>
            <SimBillRow key={ix}
              readOnly={!company||!vehicle||ixMap[ix].qualified}
              vehicle={vehicle} bill={ixMap[ix]}
              onUpdated={props.onUpdated}
              />
          )}
        </tbody>
        <tfoot>
          <SimBillRow className="total-row" readOnly={true}
            vehicle={vehicle}
            bill={{ total, month: '請款'}} />
        </tfoot>
      </table>
    </div>
  );
}



export default BillListTable;